import React from 'react';
import { Link } from 'react-router-dom';
import './GetTheApp.css';

const GetTheApp = () => {
  return (
    <div className="get-the-app-wrapper">
      <div className="get-the-app-title">Get the App</div>
      <Link to={'/about-casinoverse'}>
        <div className="get-the-app-link">Download</div>
      </Link>
    </div>
  );
};

export default GetTheApp;
